export default __webpack_public_path__ + "static/media/open-sales-order.dec19aab.svg";